<div class="ui-ta-wrap">
  <textarea
    #ta
    class="ui-ta"
    [class.invalid]="invalid"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [attr.rows]="rows"
    [attr.maxlength]="maxlength"
    [style.min-height.px]="minHeight"
    (input)="onInput($event)"
    (blur)="onBlur()"
  ></textarea>
  <span class="ui-ta-count">{{ count }} символов</span>
</div>

@if (hasExample) {
  <button
    type="button"
    class="ui-ta-example-toggle"
    [attr.data-open]="showExample"
    (click)="toggleExample()"
  >
    <i class="fas fa-wand-magic-sparkles"></i>
    {{ showExample ? 'Скрыть пример' : 'Показать пример' }}
    <i class="fas fa-chevron-down chev"></i>
  </button>

  @if (showExample) {
    <div class="ui-ta-example">
      <b>Пример хорошего ответа</b>
      {{ example }}
      <div class="ins">
        <button type="button" (click)="insertExample()">Вставить пример →</button>
      </div>
    </div>
  }
}
